import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

export const useAdminStore = create(
  persist(
    (set) => ({
      token: null,

      login: async (username, password) => {
        const res = await axios.post(`${API}/admin/login`, { username, password });
        set({ token: res.data.access_token });
      },

      logout: () => set({ token: null }),
    }),
    { name: 'seoul-admin' }
  )
);
